var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 46,
    viewBox: "0 0 35 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8725 13.8625H3L7.59352 33.7612H22.8992L26.7259 2H34.7617",
    stroke: "#F07F3C",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2529 45.57C14.8671 45.57 16.1757 44.2614 16.1757 42.6472C16.1757 41.0329 14.8671 39.7244 13.2529 39.7244C11.6387 39.7244 10.3301 41.0329 10.3301 42.6472C10.3301 44.2614 11.6387 45.57 13.2529 45.57Z",
    fill: "#F07F3C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2536 43.6214C13.7916 43.6214 14.2278 43.1852 14.2278 42.6471C14.2278 42.109 13.7916 41.6729 13.2536 41.6729C12.7155 41.6729 12.2793 42.109 12.2793 42.6471C12.2793 43.1852 12.7155 43.6214 13.2536 43.6214Z",
    stroke: "#F07F3C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8916 45.57C28.5058 45.57 29.8144 44.2614 29.8144 42.6472C29.8144 41.0329 28.5058 39.7244 26.8916 39.7244C25.2773 39.7244 23.9688 41.0329 23.9688 42.6472C23.9688 44.2614 25.2773 45.57 26.8916 45.57Z",
    fill: "#F07F3C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8922 43.6214C27.4303 43.6214 27.8665 43.1852 27.8665 42.6471C27.8665 42.109 27.4303 41.6729 26.8922 41.6729C26.3542 41.6729 25.918 42.109 25.918 42.6471C25.918 43.1852 26.3542 43.6214 26.8922 43.6214Z",
    stroke: "#F07F3C",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanier);
export default __webpack_public_path__ + "static/media/panier.6e27b0042b23d1dc6c6921483bfb8be4.svg";
export { ForwardRef as ReactComponent };